<div class="container-margin">
  <div class="content">
    <h2>{{ title }}</h2>
    <div class="container margin-top-40">
      <form [formGroup]="ingredientForm">
        <div class="form-groups">
          <div class="form-group margin-top-10">
            <mat-form-field appearance="outline">
              <mat-label>{{ translationService.getNameText() }}</mat-label>
              <input
                matInput
                type="text"
                name="name"
                formControlName="name"
                autocomplete="off"
                [readonly]="isEditMode"
                minlength="2"
              />
            </mat-form-field>
          </div>
          <div class="form-group margin-top-10">
            <mat-form-field class="chip-list" appearance="outline">
              <mat-label>{{
                translationService.getOtherNamesText()
              }}</mat-label>
              <mat-chip-grid
                #otherNamesChipGrid
                aria-label="Enter other names"
                name="otherNames"
              >
                @for (otherName of otherNames(); track otherName) {
                  <mat-chip-row
                    (removed)="removeOtherName(otherName)"
                    [editable]="true"
                    (edited)="editOtherName(otherName, $event)"
                    [aria-description]="
                      translationService.getPressEnterToEditText() +
                      ' ' +
                      otherName
                    "
                  >
                    {{ otherName }}
                    <button
                      matChipRemove
                      [attr.aria-label]="
                        translationService.getRemoveText() + ' ' + otherName
                      "
                    >
                      <mat-icon>cancel</mat-icon>
                    </button>
                  </mat-chip-row>
                }
                <input
                  [placeholder]="translationService.getNewAliasText()"
                  [matChipInputFor]="otherNamesChipGrid"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur"
                  (matChipInputTokenEnd)="addOtherName($event)"
                />
              </mat-chip-grid>
            </mat-form-field>
          </div>
          <div class="form-group margin-top-10">
            <mat-form-field class="chip-list" appearance="outline">
              <mat-label>{{
                translationService.getCasNumbersText()
              }}</mat-label>
              <mat-chip-grid
                #casNumbersChipGrid
                aria-label="Enter CAS numbers"
                name="casNumbers"
              >
                @for (casNumber of casNumbers(); track casNumber) {
                  <mat-chip-row
                    (removed)="removeCasNumber(casNumber)"
                    [editable]="true"
                    (edited)="editCasNumber(casNumber, $event)"
                    [aria-description]="
                      translationService.getPressEnterToEditText() +
                      ' ' +
                      casNumber
                    "
                  >
                    {{ casNumber }}
                    <button
                      matChipRemove
                      [attr.aria-label]="
                        translationService.getRemoveText() + ' ' + casNumber
                      "
                    >
                      <mat-icon>cancel</mat-icon>
                    </button>
                  </mat-chip-row>
                }
                <input
                  [placeholder]="translationService.getNewCasNumberText()"
                  [matChipInputFor]="casNumbersChipGrid"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur"
                  (matChipInputTokenEnd)="addCasNumber($event)"
                />
              </mat-chip-grid>
            </mat-form-field>
          </div>
        </div>
        <div class="actions margin-top-10">
          <button
            mat-raised-button
            extended
            color="primary"
            class="action-item"
            (click)="onSubmit()"
          >
            <mat-icon>add</mat-icon>
            {{ translationService.getSubmitText() }}
          </button>
          <button
            type="button"
            mat-stroked-button
            extended
            color="primary"
            class="action-item"
            (click)="onReset()"
          >
            <mat-icon>refresh</mat-icon>
            {{ translationService.getResetText() }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
